const styleOverrides = {
  filled: {
    '&.MuiInputAdornment-positionStart&:not(.MuiInputAdornment-hiddenLabel)': {
      marginTop: 0
    }
  }
};
export default {
  styleOverrides
};